"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LTVectorlayer = exports.LayerInfos = void 0;
const rbush_1 = __importDefault(require("rbush"));
const ltpoint_js_1 = require("../cad/ltpoint.js");
const ltfeature_1 = require("./ltfeature");
const ltfields_js_1 = require("./ltfields.js");
const ltrendermode_js_1 = require("../ltrendermode.js");
const ltentity_js_1 = require("../cad/ltentity.js");
class LayerInfos {
    constructor() {
        this.entities = [];
        this.linetypescales = [];
        this.lineWidth = [];
    }
    LayerInfos() {
    }
    setEntities(ent) {
        if (this.entities.indexOf(ent) === -1) {
            this.entities.push(ent);
        }
    }
    setLinetypescale(scale) {
        if (!isNaN(scale * 1)) {
            scale = scale * 1;
        }
        if (this.linetypescales.indexOf(scale) === -1) {
            this.linetypescales.push(scale);
        }
    }
    setLineWidth(width) {
        if (!isNaN(width * 1)) {
            width = width * 1;
        }
        if (this.lineWidth.indexOf(width) === -1) {
            this.lineWidth.push(width);
        }
    }
}
exports.LayerInfos = LayerInfos;
;
class LTVectorlayer {
    constructor(name) {
        this._isForzen = false;
        this._isLocked = false;
        this._isOff = false;
        //默认为白色;
        this._colorInfo = {
            aci: true,
            color: "0xFFFFFF",
            index: 7
        };
        this._linetype = "";
        this._linewidth = 0;
        this._layerInfos = null;
        this._name = name;
        this._rbush = new rbush_1.default();
        this._items = [];
        this._fields = ltfields_js_1.LTField.createFields();
        this._linetype = "";
        this._linewidth = 0;
        this._layerInfos = new LayerInfos();
        //添加绘图显示;
        this._layer_graphics = ltrendermode_js_1.CadSetting._newGraphics();
        window.cadmap.mapContainer.addChild(this._layer_graphics);
    }
    //获取图层名
    get name() {
        return this._name;
    }
    set name(n) {
        this._name = n;
    }
    get visible() {
        let ok = this._isOff || this._isForzen;
        return !ok;
    }
    get layerGraphics() {
        return this._layer_graphics;
    }
    invalidate() {
        this.layerGraphics.geometry.invalidate();
    }
    clearGraphics() {
        if (this._layer_graphics.parent) {
            this._layer_graphics.parent.removeChild(this._layer_graphics);
            this._layer_graphics.destroy({ children: true }); // 这将递归销毁容器及其所有子对象
            this._layer_graphics = ltrendermode_js_1.CadSetting._newGraphics();
            window.cadmap.mapContainer.addChild(this._layer_graphics);
        }
    }
    //获取颜色
    get color() {
        return this._colorInfo.color;
    }
    set color(c) {
        this._colorInfo.color = c;
        this._colorInfo.aci = false;
        this._colorInfo.index = "-1";
    }
    setColorInfo(json) {
        this._colorInfo = json;
    }
    getColorInfo() {
        return this._colorInfo;
    }
    get locked() {
        return this._isLocked;
    }
    set locked(l) {
        this._isLocked = l;
    }
    set forzen(f) {
        this._isForzen = f;
        if (this._layer_graphics) {
            if (this._isOff || this._isForzen) {
                this._layer_graphics.visible = false;
            }
            else {
                this._layer_graphics.visible = true;
            }
        }
    }
    get forzen() {
        return this._isForzen;
    }
    get off() {
        return this._isOff;
    }
    set off(o) {
        this._isOff = o;
        if (this._layer_graphics) {
            if (this._isOff || this._isForzen) {
                this._layer_graphics.visible = false;
            }
            else {
                this._layer_graphics.visible = true;
            }
        }
    }
    get fields() {
        return this._fields;
    }
    getSaveInfo() {
        let info = {
            color: this.getColorInfo(), isFrozen: this._isForzen, isLocked: this._isLocked, isOff: this._isOff,
            linetype: this._linetype, linewidth: this._linewidth
        };
        let json = { info: info, layername: this._name };
        return json;
    }
    getLayerInfo() {
        if (this._layerInfos == null) {
            this._layerInfos = new LayerInfos();
            this._items.forEach(element => {
                var _a, _b, _c;
                let geometry = element.feature.getGeometry();
                (_a = this._layerInfos) === null || _a === void 0 ? void 0 : _a.setEntities(geometry.data.getShapeName());
                (_b = this._layerInfos) === null || _b === void 0 ? void 0 : _b.setLinetypescale(geometry._linetypescale);
                (_c = this._layerInfos) === null || _c === void 0 ? void 0 : _c.setLineWidth(geometry._linewidth);
            });
        }
        return this._layerInfos;
    }
    addFeature(fea, item, isupdateRBush) {
        if (ltrendermode_js_1.CadSetting.Instance.useOnlyRender) {
            this._items.push(item);
            return;
        }
        this._items.push(item);
        if (isupdateRBush == true) {
            this._rbush.insert(item);
        }
        //需要重新更新
        this._layerInfos = null;
    }
    //初始化空间索引
    updateRBush(use_render = false) {
        if (ltrendermode_js_1.CadSetting.Instance.useOnlyRender) {
            return;
        }
        this._items.forEach(fea_item => {
            if (fea_item.feature.getGeometry() === null) {
                return;
            }
            let temp_ent = fea_item.feature.getGeometry();
            let rbox = null;
            if (use_render && temp_ent._bounds !== undefined && isFinite(temp_ent._bounds.minX) && isFinite(temp_ent._bounds.minY)
                && isFinite(temp_ent._bounds.maxX) && isFinite(temp_ent._bounds.maxY)) {
                rbox = new ltpoint_js_1.RBox(temp_ent._bounds.minX, temp_ent._bounds.minY, temp_ent._bounds.maxX, temp_ent._bounds.maxY);
            }
            else {
                rbox = fea_item.feature.getGeometry().getBoundingBox();
            }
            if (Number.isNaN(rbox.getWidth())) {
                return;
            }
            let min_point = rbox.getMinimum();
            let max_point = rbox.getMaximum();
            fea_item.minX = min_point.x;
            fea_item.minY = min_point.y;
            fea_item.maxX = max_point.x;
            fea_item.maxY = max_point.y;
        });
        this._rbush = new rbush_1.default();
        this._rbush.load(this._items);
    }
    boundingBox() {
        //获取外包范围;
        let any_rush = this._rbush;
        let root = any_rush.data;
        return new ltpoint_js_1.RBox(root.minX, root.minY, root.maxX, root.maxY);
    }
    //框选
    getFeatures(bounds, callback = null, deletefeature = false) {
        let features = [];
        if (this._items.length === 0) {
            return features;
        }
        if (this.visible == false) {
            return [];
        }
        if (bounds == null) {
            this._items.forEach(element => {
                //删除的不要
                if (!deletefeature && element.feature.state === ltfeature_1.CommitFlag.Delete) {
                    return;
                }
                if (element.feature.getGeometry().visible == false) {
                    return;
                }
                if (callback == null) {
                    features.push(element.feature);
                }
                else {
                    if (callback(element.feature, bounds)) {
                        features.push(element.feature);
                    }
                }
            });
            return features;
        }
        function containCallback(feature, line) {
            let geo = feature.getGeometry().data;
            //包含
            if (line.subData().contain(geo)) {
                return true;
            }
            //相交
            if (geo.intersectsWith(line.subData(), true)) {
                return true;
            }
            return false;
        }
        let containCB = null;
        let mbounds = {};
        let line = {};
        if (bounds instanceof ltentity_js_1.LTPolyline) {
            line = bounds;
            mbounds = bounds.getBoundingBox();
            containCB = containCallback;
        }
        else {
            mbounds = bounds;
        }
        let min = mbounds.getMinimum();
        let max = mbounds.getMaximum();
        let feas = this._rbush.search({
            minX: min.x,
            minY: min.y,
            maxX: max.x,
            maxY: max.y
        });
        for (let i = 0; i < feas.length; i++) {
            //判断是否在线里面
            if (containCB !== null) {
                if (!containCB(feas[i].feature, line)) {
                    continue;
                }
            }
            if (callback == null) {
                features.push(feas[i].feature);
            }
            else {
                if (callback(feas[i].feature, bounds)) {
                    features.push(feas[i].feature);
                }
            }
        }
        return features;
    }
    //获取单个 点选
    getFeature(bounds, callback = null) {
        if (this._items.length === 0) {
            return null;
        }
        if (!this.visible) {
            return null;
        }
        let feas = this._rbush.search({
            minX: bounds.getMinimum().x,
            minY: bounds.getMinimum().y,
            maxX: bounds.getMaximum().x,
            maxY: bounds.getMaximum().y
        });
        var feature = null;
        let max_diastance = null;
        for (let i = 0; i < feas.length; i++) {
            if (feas[i].feature.getGeometry().visible == false) {
                continue;
            }
            if (callback == null) {
                let dis = feas[i].feature.getGeometry().data.getDistanceTo(bounds.getCenter());
                if (max_diastance == null || dis < max_diastance) {
                    feature = feas[i].feature;
                    max_diastance = dis;
                }
            }
            else {
                if (callback(feas[i].feature, bounds)) {
                    let dias = feas[i].feature.getGeometry().data.getDistanceTo(bounds.getCenter());
                    if (max_diastance == null || dias < max_diastance) {
                        feature = feas[i].feature;
                        max_diastance = dias;
                    }
                }
            }
        }
        if (callback == null) {
            if (max_diastance != null && max_diastance > bounds.getWidth()) {
                return null;
            }
        }
        return feature;
    }
    removeFeature(fea) {
        //不用移除 状态更新了就行
        // this._features = this._features.filter(item => {
        //   return item !== fea;
        // });
        if (fea.item !== null) {
            this._rbush.remove(fea.item);
        }
        //this._items = this._rbush.all();
        //需要重新更新
        this._layerInfos = null;
    }
    updateFeature(fea, item) {
        if (fea.item != null) {
            this._rbush.remove(fea.item);
        }
        fea.item = item;
        this._rbush.insert(fea.item);
        // this._items = this._rbush.all();
        //需要重新更新
        this._layerInfos = null;
    }
}
exports.LTVectorlayer = LTVectorlayer;
